import { API } from "@/constants/common/urls";
import { axios } from "@/imports-files/common/common";
import { SendRequest } from "@/services/common/send-request";

export class MergeRecordsService extends SendRequest {
    async getMergeCandidateData(params, candidate_id) {
        try {
            const result = await axios.get(API.client.jobs.GET_MERGE_CANDIDATE_DATA.replace('$candidate_id', candidate_id),
                {
                    params: params,
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

    async rejectMergeCandidateData(params, candidate_id) {
        try {
            const result = await axios.post(API.client.jobs.REJECT_MERGE_CANDIDATE.replace('$candidate_id', candidate_id),
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

     async sendMergeCandidateData(params, candidate_id) {
        try {
            const result = await axios.post(API.client.jobs.SEND_MERGE_CANDIDATE.replace('$candidate_id', candidate_id),
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

    async acceptAgencyApplication(params){
      try {
        const result = await axios.post(API.client.jobs.ACCEPT_MERGE_APPLICATION.replace('$job_application_id', params.job_application_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      }
      catch (error) {
        return error;
      }
    }

    async rejectAgencyApplication(params){
      try {
        const result = await axios.post(API.client.jobs.REJECT_MERGE_APPLICATION.replace('$job_application_id', params.duplicate_application_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      }
      catch (error) {
        return error;
      }
    }
}
